var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2677 0.999999C12.0375 -0.333334 13.962 -0.333333 14.7318 1L25.1241 19C25.8939 20.3333 24.9317 22 23.3921 22H2.60747C1.06787 22 0.105625 20.3333 0.875425 19L11.2677 0.999999Z",
    fill: "#FFCF3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5893_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 8.05005C9.7198 8.05005 7.0498 10.72 7.0498 14C7.0498 17.28 9.7198 19.95 12.9998 19.95C16.2798 19.95 18.9498 17.28 18.9498 14C18.9498 10.72 16.2798 8.05005 12.9998 8.05005ZM12.9998 19.05C10.2148 19.05 7.9498 16.785 7.9498 14C7.9498 11.215 10.2148 8.95005 12.9998 8.95005C15.7848 8.95005 18.0498 11.215 18.0498 14C18.0498 16.785 15.7848 19.05 12.9998 19.05ZM12.9998 14.535C13.2748 14.535 13.4998 14.31 13.4998 14.035V11.25C13.4998 10.975 13.2748 10.75 12.9998 10.75C12.7248 10.75 12.4998 10.975 12.4998 11.25V14.035C12.4998 14.31 12.7248 14.535 12.9998 14.535ZM13.6248 16.125C13.6248 16.4702 13.3449 16.75 12.9998 16.75C12.6546 16.75 12.3748 16.4702 12.3748 16.125C12.3748 15.7799 12.6546 15.5 12.9998 15.5C13.3449 15.5 13.6248 15.7799 13.6248 16.125Z",
    fill: "#293035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5893_1445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ead3bf45c34585c9a5f655a84279328e.svg";
export { ForwardRef as ReactComponent };